import React, { Component } from "react";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";

// datatable related plugins
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import SweetAlert from "react-bootstrap-sweetalert";
import styled from "styled-components";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import RemoteTable from "../../../components/Common/RemoteTable";
import {
  addContractor,
  deleteContractor,
  getContractorsList,
} from "../../../store/contractors/actions";
import { INITIAL_DATA_PARAMS } from "../../../constants/store";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class Contractors extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      filter_name: [],
      deleteAlert: null,
    };
  }

  componentDidMount() {
    this.props.getContractorsList({
      ...INITIAL_DATA_PARAMS,
    });
  }

  handleTableChange = data => {
    this.props.getContractorsList(data);
  };

  handleChangeDeleteAlert = data => {
    this.setState({ deleteAlert: data });
  };

  toggleAddContractor = () => {
    this.props.history.push(`/contractors/add`);
  };

  render() {
    const actionsFormatter = (cell, row) => {
      const onClickDelete = () => {
        this.handleChangeDeleteAlert({
          title: `Delete "${row.counterparty_name}"!`,
          onConfirm: () => {
            this.props.deleteContractor(row.id, {
              ...this.props.data,
              page:
                this.props.data.results.length === 1 ? 1 : this.props.data.page,
            });
            this.handleChangeDeleteAlert(null);
          },
        });
      };

      const onClickEdit = e => {
        onClickRow(e, row);
      };

      return (
        <React.Fragment>
          {!!this.props.permissions?.["change_contractmodel"] && (
            <Button
              type="button"
              className="btn btn-primary  btn-sm"
              onClick={onClickEdit}
            >
              <i className="mdi mdi-circle-edit-outline d-block font-size-16" />
            </Button>
          )}
          {!!this.props.permissions?.["delete_contractmodel"] && (
            <Button
              type="button"
              className="btn btn-danger btn-sm m-1"
              onClick={onClickDelete}
            >
              <i className="mdi mdi-trash-can d-block font-size-16" />
            </Button>
          )}
        </React.Fragment>
      );
    };

    const nameFormatter = (cell, row, label) => {
      return (
        <NameLink onClick={e => onClickRow(e, row)}>{row[label]}</NameLink>
      );
    };

    const columns = [
      {
        dataField: "counterparty_name",
        text: "Counterparty name",
        sort: true,
        formatter: (cell, row) => nameFormatter(cell, row, "counterparty_name"),
      },
      {
        dataField: "contract_number",
        text: "Contract number",
        sort: true,
        formatter: (cell, row) => nameFormatter(cell, row, "contract_number"),
      },
      {
        dataField: "date_of_signature",
        text: "Date of signature",
        sort: true,
        formatter: (cell, row) => nameFormatter(cell, row, "date_of_signature"),
      },
      {
        dataField: "expiration",
        text: "Expiration",
        sort: true,
        formatter: (cell, row) => nameFormatter(cell, row, "expiration"),
      },
      {
        dataField: "actions",
        text: "Actions",
        sort: false,
        formatter: actionsFormatter,
      },
    ];

    const onClickRow = (e, row) => {
      this.props.history.push(`/contractors/${row.id}`);
    };

    return (
      <React.Fragment>
        <div className="page-content">
          <ModifiedMetaTags title="Contractors | Mobihunter" />
          
          <Container fluid>
            <Breadcrumbs
              title="Dashboard"
              breadcrumbItem="Contractors"
              link="/dashboard"
            />
            {this.state.deleteAlert && (
              <SweetAlert
                showCancel
                confirmBtnText="Delete"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle=""
                title={this.state.deleteAlert.title}
                onCancel={() => this.handleChangeDeleteAlert(null)}
                onConfirm={this.state.deleteAlert.onConfirm}
              >
                <p>
                  You are about to delete this contractor? <br /> If you are not
                  sure, you can close this form.
                </p>
              </SweetAlert>
            )}

            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <RemoteTable
                      onTableChange={this.handleTableChange}
                      columns={columns}
                      data={this.props.data}
                      loading={this.props.loading}
                    >
                      {!!this.props.permissions?.["add_contractmodel"] && (
                        <Button
                          type="button"
                          color="success"
                          className="btn-rounded mb-2 me-2"
                          onClick={this.toggleAddContractor}
                        >
                          <i className="mdi mdi-plus me-1" /> Add contractor
                        </Button>
                      )}
                    </RemoteTable>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const NameLink = styled.div`
  transition-duration: 0.1s;
  &:hover {
    color: rgb(85, 110, 230);
    transition-duration: 0.1s;
  }
`;

Contractors.propTypes = {
  data: PropTypes.shape({
    page: PropTypes.number,
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  getContractorsList: PropTypes.func.isRequired,
  addContractor: PropTypes.func.isRequired,
  deleteContractor: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  permissions: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  data: state.ContractorList.data,
  loading: state.ContractorList.loading,
  permissions: state.User.permissions,
});

export default connect(mapStateToProps, {
  getContractorsList,
  addContractor,
  deleteContractor,
})(Contractors);
